app.service('servicesSection', function (productCardConfig, store, modal, loading, availableServicesModal, productCardManager) {
	let $self;
	let $moreServices;
	let services = []; // { isVisible: boolean, id: number, featured: boolean, $input: jQuery Object, $el: jQuery Object }

	function init(props) {
		setElements(props);
		setEvents();

		setInitServiceOrder();
		const { services: activeServices, servicesOrder: order } = productCardManager.get();
		showUserSelectedServices(activeServices, order);

		render();
	}

	function setElements(props) {
		$self = props.$el.find('.services-section');
		const $services = props.$el.find('.service').not('.delivery-information');
		services = createServiceList($services);
		services.filter(service => service.featured).slice(0, 3).forEach(service => service.show()); // na start pokazujemy 3 pierwsze usługi z flagą show = true
		$moreServices = props.$el.find('.js-more-services');
	}

	function setInitServiceOrder() {
		services.filter(service => service.isVisible).map(service => {
			addServiceToCartDataOrder(service.id);
		});
	}

	function showUserSelectedServices(servicesID, orderIDs) {
		if(!servicesID.length) return;
		servicesID.forEach((id) => services.find(service => service.id === id).show());

		//Sort by OrderIDs
		if(orderIDs.length) {
			orderIDs.forEach(orderId => {
				let elem = services.find(service => service.id === orderId)
				$self.find('.services').append(elem.$el);
			});
		}
	}

	function createServiceList($services) {
		return $services.map(function () {
			const serviceId = parseInt($(this).find('input').val());
			return {
				id: serviceId,
				isVisible: false,
				featured: $(this).data('featured'),
				$input: $(this).find('input[type=checkbox]'),
				$el: $(this),
				show() {
					this.isVisible = true;
					this.$el.addClass('is-visible');
				}
			};
		}).toArray();
	}

	function setEvents() {
		$self
			.on('change', '.js-toggle-service', handleSelectServiceClick)
			.on('click', '.js-more-services', handleSelectMoreServicesClick)
			.on('click', '.js-show-service-details', handleShowServiceDetails);
	}

	function handleShowServiceDetails(e) {
		e.preventDefault();
		availableServicesModal.showServiceInfoModal($(this).data('service-id') , handleSelectedServicesChange);
		UA.interaction('KP_Crossell', 'Uslugi_' + $(this).data('service-id') + '_infoTip', 'Klikniecie');
	}

	function handleSelectServiceClick() {
		const serviceId = parseInt(this.value);
		if (this.checked) {
			productCardManager.addService(serviceId);
		} else {
			productCardManager.removeService(serviceId);
		}
		UA.interaction('KP_Crossell', 'Uslugi_' + serviceId, 'Klikniecie');
	}

	function handleSelectMoreServicesClick() {
		loadAvailableServicesModal();
		UA.interaction('KP_Crossell', 'Uslugi_Wiecej_uslug', 'Klikniecie');
	}

	function loadAvailableServicesModal() {
		loading.start();

		fetchAvailableServices()
			.then(content => {
				availableServicesModal.show({
					content,
					onChange: handleSelectedServicesChange
				});
			})
			.fail(() => modal.alert('Błąd ładowania informacji o usługach. Odśwież stronę i spróbuj ponownie.'))
			.always(loading.stop);
	}

	function handleSelectedServicesChange(serviceId) {
		if (productCardManager.hasService(serviceId)) {
			let service = services.find(item => item.id === serviceId);
			if(!service.isVisible) {
				$self.find('.services').append(service.$el);
			}
			service.show();
			addServiceToCartDataOrder(serviceId);
		}

		render();
	}

	function addServiceToCartDataOrder(serviceId) {
		if(!productCardManager.hasServiceInOrder(serviceId)) {
			productCardManager.addServiceToOrder(serviceId)
		}
	}

	function fetchAvailableServices() {
		const config = productCardConfig.getData();
		return $.ajax({
			url: '/web-cached/available-services.ltr',
			data: {
				productId: config.id,
				outletCategoryId: store.data.outletCategoryId || undefined,
				instalmentCode: store.data.instalmentCode || undefined,
				instalmentNumber: store.data.instalmentNumber || undefined
			}
		});
	}

	function render() {
		services.forEach(service => {
			const isServiceSelected = productCardManager.hasService(service.id);
			service.$input.prop('checked', isServiceSelected);
		});

		const visibleServicesCount = services.filter(service => service.isVisible).length;
		const hiddenServicesCount = services.length - visibleServicesCount;

		if (hiddenServicesCount >= 1) {
			$moreServices.text(`Więcej usług (${hiddenServicesCount})`);
			$moreServices.addClass('is-visible');
		} else {
			$moreServices.removeClass('is-visible');
		}
	}

	return {
		init
	};
});